import { render, staticRenderFns } from "./c_txt_tab.vue?vue&type=template&id=24c61518&scoped=true"
import script from "./c_txt_tab.vue?vue&type=script&lang=js"
export * from "./c_txt_tab.vue?vue&type=script&lang=js"
import style0 from "./c_txt_tab.vue?vue&type=style&index=0&id=24c61518&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c61518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c61518')) {
      api.createRecord('24c61518', component.options)
    } else {
      api.reload('24c61518', component.options)
    }
    module.hot.accept("./c_txt_tab.vue?vue&type=template&id=24c61518&scoped=true", function () {
      api.rerender('24c61518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileConfigRight/c_txt_tab.vue"
export default component.exports